import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

/**
 * Bloque de manual con estilo tipo landing pádel (destacado vs cuerpo).
 * @param {'highlight'|'plain'} variant
 */
const WikiManualSection = ({ title, contentHtml, variant = 'plain' }) => {
  const theme = useTheme();
  const isHighlight = variant === 'highlight';

  return (
    <Box
      sx={
        isHighlight
          ? {
            py: 4,
            px: 3,
            borderRadius: 2,
            bgcolor: theme.palette.alternate.main,
            borderLeft: 4,
            borderColor: theme.palette.primary.main,
          }
          : { py: 2 }
      }
    >
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 700 }}
        variant="overline"
        color="primary"
        display="block"
        gutterBottom
      >
        Manual interno
      </Typography>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        {title}
      </Typography>
      <Box
        component="div"
        sx={{
          '& p': { mb: 2 },
          '& ul': { pl: 2.5, mb: 2 },
          '& li': { mb: 0.5 },
          '& strong': { color: 'text.primary' },
        }}
        dangerouslySetInnerHTML={{ __html: contentHtml }}
      />
    </Box>
  );
};

WikiManualSection.propTypes = {
  title: PropTypes.string.isRequired,
  contentHtml: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['highlight', 'plain']),
};

export default WikiManualSection;
